import {client} from "./client"
import {AxiosError, AxiosResponse} from "axios"

const responseBody = (response: AxiosResponse) => response.data

export const HelpService = {
  Send: (email: string, message: string): Promise<void> => client.post("/help", {email: email, message: message}).then(responseBody)
}
